import { createSlice } from '@reduxjs/toolkit';
import { productVariationCreate } from './productAsyncThunk';

const productVariationCreateSlice = createSlice({
  name: "product",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productVariationCreate.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productVariationCreate.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productVariationCreate.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productVariationCreateSlice.reducer;